import styled from 'styled-components'

export const Container = styled.div`
	table {
		margin-top: 0 !important;
	}

	form {
		display: grid;
		grid-template-columns: 0.7fr 0.8fr 0.5fr 1.2fr;
		grid-template-areas:
			'title title title title'
			'tipo valor btn table';

		> h1 {
			grid-area: title;
			margin: 8px 10px 0;
		}

		> button {
			margin: 23px 30px 0 8px;
		}

		.table-container {
			grid-area: table;
			margin: 22px 8px;
			width: calc(100% - 16px);
		}

		&.media-social-form {
			margin-top: 24px;
		}

		@media(max-width: 900px) {
			grid-template-columns: 1fr 1fr auto;
			grid-template-areas:
				'title title title'
				'tipo valor btn'
				'table table table';
		}

		@media(max-width: 600px) {
			display: flex;
			flex-direction: column;

			> button {
				width: calc(100% - 16px);
			}
		}
	}
`
